import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('NewPlatformMark').create(({ theme }) => ({
  root: {
    display: 'flex',

    padding: '4px 5px',

    justifyContent: 'center',
    width: '34px',
    height: '18px',
    alignItems: 'center',

    gap: '10px',
    borderRadius: '24px',

    background: '#FF2A00',

    span: {
      color: theme.colors.text.primary,
      textAlign: 'center',
      fontSize: '10px',
      fontWeight: '700',
    },
  },
}))
